import { useEffect } from 'react';
import Navbar from './components/Navbar.jsx';
import Hero from './components/Hero.jsx';
import Stats from './components/Stats.jsx';
import About from './components/About.jsx';
import Results from './components/Results.jsx';
import Process from './components/Process.jsx';
import Pricing from './components/Pricing.jsx';
import Calculator from './components/Calculator.jsx';
import Testimonials from './components/Testimonials.jsx';
import Faq from './components/Faq.jsx';
import Contact from './components/Contact.jsx';
import Booking from './components/Booking.jsx';
import Footer from './components/Footer.jsx';
import FloatingCta from './components/FloatingCta.jsx';
import { siteConfig } from './data/siteData.js';

export default function App() {
  useEffect(() => {
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'PersonalTrainer',
      name: siteConfig.brand,
      description: siteConfig.seoDescription,
      areaServed: {
        '@type': 'City',
        name: 'Székesfehérvár',
      },
      url: window.location.origin,
      email: siteConfig.contact.email,
      telephone: siteConfig.contact.phone,
      priceRange: '$$',
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => script.remove();
  }, []);

  return (
    <>
      <a className="skip-link" href="#main-content">
        Ugrás a tartalomhoz
      </a>
      <Navbar />
      <main id="main-content">
        <Hero />
        <Stats />
        <About />
        <Results />
        <Process />
        <Pricing />
        <Calculator />
        <Testimonials />
        <Booking />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <FloatingCta />
    </>
  );
}
